import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { decodeHtmlEntities } from "../containers/utils";

const SoftwareInterestComponent = ({ onCategoryChange, fetchLeadsData }) => {
  const [selectedCategories, setSelectedCategories] = useState(new Set(["All"]));
  const [categories, setCategories] = useState([]); // Initialize without "All"
  const [totalLeads, setTotalLeads] = useState(0); // State to store total leads count

  const extractCategoriesFromLeads = useCallback(() => {
    const categoriesMap = new Map();

    fetchLeadsData.forEach((lead) => {
      const researchArea = lead.softwareinterest
          ? decodeHtmlEntities(lead.softwareinterest.trim())
          : "Uncategorized";
      const normalized = decodeHtmlEntities(lead.softwareinterest?.trim() || "Uncategorized");
      categoriesMap.set(normalized, (categoriesMap.get(normalized) || 0) + 1);
    });

    let categoriesArray = Array.from(categoriesMap.entries());

    // Ensure 'Uncategorized' is the last item
    categoriesArray = categoriesArray.sort(([a], [b]) => {
      if (a === "Uncategorized") return 1;
      if (b === "Uncategorized") return -1;
      return a.localeCompare(b);
    });

    return categoriesArray;
  }, [fetchLeadsData]);

  useEffect(() => {
    if (!fetchLeadsData || fetchLeadsData.length === 0) {
      return;
    }

    const researchAreas = extractCategoriesFromLeads();

    setCategories(researchAreas);
    setTotalLeads(fetchLeadsData.length); // Set the total leads count
  }, [fetchLeadsData, extractCategoriesFromLeads]);

  const toggleCategory = (category) => {
    const normalizedCategory = decodeHtmlEntities(category.trim());

    setSelectedCategories((prevSelected) => {
      let updatedCategories = new Set(prevSelected);

      if (normalizedCategory === "All") {
        updatedCategories = new Set(["All"]);
      } else {
        updatedCategories.delete("All");

        if (updatedCategories.has(normalizedCategory)) {
          updatedCategories.delete(normalizedCategory);
        } else {
          updatedCategories.add(normalizedCategory);
        }

        if (updatedCategories.size === 0) {
          updatedCategories.add("All");
        }
      }

      console.log("Selected Categories:", updatedCategories);

      onCategoryChange(updatedCategories);
      return updatedCategories;
    });
  };

  return (
      <div>
        <p className="filter-by-research">Filter by software interest:</p>
        <div className="categories">
          <button
              key="All"
              className={`filter-research ${selectedCategories.has("All") ? "active" : ""}`}
              onClick={() => toggleCategory("All")}
          >
            All ({totalLeads})
          </button>
          {categories.map(([category, count]) => (
              <button
                  key={category}
                  className={`filter-research ${selectedCategories.has(category) ? "active" : ""}`}
                  onClick={() => toggleCategory(category)}
              >
                {category} ({count})
              </button>
          ))}
        </div>
      </div>
  );
};

SoftwareInterestComponent.propTypes = {
  onCategoryChange: PropTypes.func.isRequired,
  fetchLeadsData: PropTypes.array.isRequired,
};

export default SoftwareInterestComponent;
